import React, { useState } from 'react';

import { CardId, isValidCard } from '../api/card';

import Card, { CardBody, CardFooter } from './Card';
import CardInput, { CardInputState } from './CardInput';

type CardFormProps = {
  setCard: (card: CardId) => void;
};

function CardForm({ setCard }: CardFormProps): JSX.Element {
  const [state, setState] = useState<CardInputState>({
    type: '',
    number: ''
  });
  const isValid = isValidCard(state);

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    // Check in case the browser ignores the `disabled` attribute
    if (isValid) {
      setCard({ type: state.type, number: state.number });
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <CardBody>
          <CardInput state={state} setState={setState} />
        </CardBody>
        <CardFooter>
          <button
            type="submit"
            disabled={!isValid}
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-indigo-400"
          >
            Check
          </button>
        </CardFooter>
      </Card>
    </form>
  );
}

export default CardForm;
